import React, { Dispatch, createContext, useContext } from "react";

type WidgetSettingsEmployeeLeaveContextType = {
  leaveReasonIds: string[];
  setLeaveReasonIds: Dispatch<React.SetStateAction<string[]>>;
  teamIds: string[];
  setTeamIds: Dispatch<React.SetStateAction<string[]>>;
  storecastId: string;
};

const WidgetSettingsEmployeeLeaveContext = createContext<
  WidgetSettingsEmployeeLeaveContextType | undefined
>(undefined);

export const WidgetSettingsEmployeeLeaveContextProvider =
  WidgetSettingsEmployeeLeaveContext.Provider;

export function useWidgetSettingsEmployeeLeaveContext() {
  const context = useContext(WidgetSettingsEmployeeLeaveContext);
  if (!context) {
    throw new Error(
      "useWidgetSettingsEmployeeLeaveContext must be used within a WidgetSettingsEmployeeLeaveContext"
    );
  }
  return context;
}
